import React, { FC } from "react";
import { createGlobalStyle } from "styled-components";
import { InputNumber } from "primereact/inputnumber";
import Container from "saur_ui_library/src/Atoms/Container/Container";
import Word from "saur_ui_library/src/Atoms/Word/Word";

type FieldProps = {
  className: string;
  placeholder: string;
  onValueChange: any;
  id: string;
  value: any;
  max?:number;
  min?:number;
  title?:string;
  disabled?:boolean
  required?:boolean
};

const InputField: FC<FieldProps> = (props) => {
  return (
    <Container className="global-field sds-reset-style">
        <Styles />
        <Word
          variant="p"
          textStyle="normalReg"
          value={props.title as string}
          className="title"
        />
        <InputNumber
          required={props.required}
          className={`field ${props.className}`}
          id={`id-field ${props.id}`}
          placeholder={props.placeholder}
          value={props.value}
          onValueChange={props.onValueChange}
          min={props.min}
          max={props.max}
          disabled={props.disabled}
        />
    </Container>
  );
};

export const Styles = createGlobalStyle`
.global-field.sds-reset-style{
    .field{
        input.p-inputtext.p-component.p-inputnumber-input{
        background-color: #edf2fa;
        border: 1px solid #edf2fa;
        height: 55px;
        margin-top:20px;
        margin-bottom:20px;
        margin-right:20px;
        padding-left: 10px;
        font-size: 14px;
        font-style: italic;
        font-family: 'Montserrat';
        color: black;
        }
    }
} 
  `;

export default InputField;
